module.exports = __webpack_public_path__ + "static/media/9DESA35.e1e3b211.jpg";